module.exports = __webpack_public_path__ + "img/variety_store.b63e5209.svg";